import WRITER_LEVELS from '../constants/writerLevels';

const getWriterLevels = () => WRITER_LEVELS.map(role => ({
  ...role,
  label: t(`writerLevels.${role.value.toLocaleLowerCase()}`, { ns: i18next.Namespace.COMMON }),
}));

export default getWriterLevels;
